import React, { useContext, useMemo } from "react";
import { LangContext } from "../../context/lang/LangContext";
import { Icons } from "../PhosphorIcon/types";
import { PhosphorIcon } from "../PhosphorIcon/PhosphorIcon";
import Colors from "../../utils/enums/colors";
import environments from "../../utils/config/environments";
import AnimatedElement from "../AnimatedElement/AnimatedElement";

const EarlyAccess = () => {
  const { messages } = useContext(LangContext);

  const bodyItem = useMemo(() => {
    return [
      {
        title: messages.earlyAccess.costSaving,
        description: messages.earlyAccess.saveCostsWhileEnhancing,
        icon: Icons.CurrencyCircleDollar,
      },
      {
        title: messages.earlyAccess.limitlessScalability,
        description: messages.earlyAccess.easilyScaleYourInfrastructure,
        icon: Icons.ChartLineUp,
      },
      {
        title: messages.earlyAccess.secureDataProtection,
        description: messages.earlyAccess.restAssuredKnowingYourData,
        icon: Icons.ShieldCheck,
      },
    ];
  }, [messages]);

  return (
    <AnimatedElement>
      <div className="EarlyAccess">
        <div className="EarlyAccess__container">
          <AnimatedElement>
            <div className="EarlyAccess__paper">
              <div className="EarlyAccess__header">
                <h1>
                  {messages.earlyAccess.bookA}{" "}
                  <span>{messages.earlyAccess.demo}</span>
                </h1>
                <p>
                  {messages.earlyAccess.requestADemoAndDiscoverHow}{" "}
                  <b>{messages.earlyAccess.focusOnGrowingYourBusiness}</b>
                </p>
              </div>
              <div className="EarlyAccess__body">
                {bodyItem.map((item, index) => {
                  return (
                    <div key={index} className="EarlyAccess__body_item">
                      <h3 className="EarlyAccess__body_item_icon">
                        <PhosphorIcon
                          icon={item.icon}
                          size={16}
                          color={Colors.Primary100}
                        />{" "}
                        {item.title}
                      </h3>
                      <p className="EarlyAccess__body_item_text">
                        {item.description}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </AnimatedElement>
          <iframe
            src={
              messages.currentLanguage === "en"
                ? environments.earlyAccessFormEnglishLink
                : environments.earlyAccessFormSpanishLink
            }
            className="EarlyAccess__form"
          ></iframe>
        </div>
      </div>
    </AnimatedElement>
  );
};

export default EarlyAccess;
